import { Flex, StarIcon, Text } from "@fluentui/react-northstar";
import { Card } from "antd";
import React from "react";
import Chart from "react-apexcharts";

const PersonalizedFeedback = ({
  personalizedFeedback = {
    percentage: 68,
    trend: {
      value: 12,
      direction: "up",
    },
  },
}) => {
  const feedbackOptions = {
    chart: { type: "radialBar", sparkline: { enabled: true } },
    colors: ["#8B5CF6"],
    plotOptions: {
      radialBar: {
        hollow: { size: "70%" },
        track: { background: "#E5E7EB" },
        dataLabels: {
          name: { show: false },
          value: {
            fontSize: "1.5rem",
            fontWeight: 600,
            color: "#8B5CF6",
            offsetY: 5,
            formatter: (val) => val + "%",
          },
        },
      },
    },
    stroke: { lineCap: "round" },
  };

  const feedbackSeries = [personalizedFeedback.percentage];
  return (
    <Card style={{ height: "100%", borderRadius: "8px" }} className="shadow">
      <Flex fill space="between">
        <Text>{"Personalized Feedback"}</Text>
        {personalizedFeedback.trend.value > 0 && (
          <Text style={{ color: "#8B5CF6", fontWeight: 500 }}>
            <StarIcon style={{ marginRight: 4 }} />+
            {personalizedFeedback.trend.value}%
          </Text>
        )}
      </Flex>
      <div style={{ margin: "16px 0 8px 0" }}>
        <Text size="larger" weight="bold" style={{ margin: 0, color: "#222" }}>
          {personalizedFeedback.percentage}%
        </Text>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Chart
          options={feedbackOptions}
          series={feedbackSeries}
          type="radialBar"
          height={130}
        />
      </div>
    </Card>
  );
};

export default PersonalizedFeedback;
